import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Table } from 'semantic-ui-react'
import PropTypes from 'prop-types'

const ClientRow = ({ name, link, createdAt }) => (
    <Table.Row>
        <Table.Cell>
            <Link to={`/admin/asiakkaat/tiedot/${name}`}>{name}</Link>
        </Table.Cell>
        <Table.Cell>{createdAt}</Table.Cell>
        <Table.Cell>
            <Link to={`/asiakkaat/${link}`}>Jaettava linkki</Link>
        </Table.Cell>
    </Table.Row>
)

const makeClientRows = client => (
    <ClientRow
        name={client.name}
        key={client.id}
        link={client.privatelink}
        createdAt={client.created_at.substring(0, 10)}
    />
)

const ClientsList = ({ clients, loading }) => {

    if (loading) return <p>Ladataan asiakkaita...</p>

    if (clients.length === 0) {
        return <p>Ei asiakkaita, aloita lisäämällä uusi</p>
    }

    return (
        <Table striped>

            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Asiakas</Table.HeaderCell>
                    <Table.HeaderCell>Luotu</Table.HeaderCell>
                    <Table.HeaderCell>Asiakkaan linkki</Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {clients.map(makeClientRows)}
            </Table.Body>

        </Table>
    )
}

const mapStoP = state => {
    return {
        loading: state.clients.loading,
        clients: state.clients.data
    }
}

ClientsList.propTypes = {
    clients: PropTypes.array.isRequired
}

export default connect(mapStoP, null)(ClientsList)
export { ClientsList }



// WEBPACK FOOTER //
// ./src/Admin/Clients/ClientsList.js